'use strict';

export default function routes($routeProvider) {
  'ngInject';
  $routeProvider
    .when('/totals', {
      template: require('./totals.pug'),
      controller: 'TotalsController',
      controllerAs: 'totals',
    });
};




// WEBPACK FOOTER //
// ./client/app/manager/totals/totals.routes.ts